<div class="st-add-team-member-label">{{ languageSettings.PSTWebAddNewTeamMemberLabel }}</div>
<mat-divider class="st-add-team-member-divider" />
<div class="st-add-team-member-container">
    <st-text-field
        [placeholder]="languageSettings.PSTWebUserHeaderIDLabel"
        [value]="newUser.UserID"
        [required]="disabled"
        [label]="languageSettings.PSTWebUserHeaderIDLabel"
        (changed)="onNewUserChanged($event, 'UserID')" />
    <st-text-field
        class="st-add-team-member-container-item"
        [placeholder]="languageSettings.PSTWebUserHeaderFirstNameLabel"
        [value]="newUser.GivenName"
        [required]="disabled"
        [label]="languageSettings.PSTWebUserHeaderFirstNameLabel"
        (changed)="onNewUserChanged($event, 'GivenName')" />
    <st-text-field
        [placeholder]="languageSettings.PSTWebUserHeaderLastNameLabel"
        [value]="newUser.Surname"
        [required]="disabled"
        [label]="languageSettings.PSTWebUserHeaderLastNameLabel"
        (changed)="onNewUserChanged($event, 'Surname')" />
    <st-text-field
        [placeholder]="languageSettings.PSTWebUserHeaderEmailLabel"
        [value]="newUser.Email"
        [label]="languageSettings.PSTWebUserHeaderEmailLabel"
        (changed)="onNewUserChanged($event, 'Email')" />
    <st-text-field
        [placeholder]="languageSettings.PSTWebUserHeaderSSOEmailLabel"
        [value]="newUser.SSOLogins"
        [label]="languageSettings.PSTWebUserHeaderSSOEmailLabel"
        (changed)="onNewUserChanged($event, 'SSOLogins')" />
    <mat-form-field>
        <mat-label>{{ languageSettings.PSTWebUserHeaderDefaultTeamLabel }}</mat-label>
        <mat-select
            [required]="disabled"
            [formControl]="internalProgramFormControl"
            [placeholder]="languageSettings.PSTWebUserHeaderDefaultTeamLabel"
            [(ngModel)]="newUser.Program">
            <mat-option
                *ngFor="let group of globalTablesService?.GroupsArray"
                [value]="group.ID">
                {{ group.Description }}
            </mat-option>
        </mat-select>
    </mat-form-field>
    <mat-form-field>
        <mat-label>{{ languageSettings.PSTWebUserHeaderRoleLabel }}</mat-label>
        <mat-select
            [required]="disabled"
            [formControl]="internalRoleFormControl"
            [placeholder]="languageSettings.PSTWebUserHeaderRoleLabel"
            [(ngModel)]="newUserCurrentRole"
            (selectionChange)="newUserSelectRole()">
            <mat-option
                *ngFor="let role of inputData.data"
                [value]="role">
                {{ role.Description }}
            </mat-option>
        </mat-select>
    </mat-form-field>
    <mat-form-field>
        <mat-label>{{ languageSettings.PSTWebUserGroupSortByStatusLabel }}</mat-label>
        <mat-select
            [required]="disabled"
            [formControl]="internalStatusFormControl"
            [placeholder]="languageSettings.PSTWebUserGroupSortByStatusLabel"
            [(ngModel)]="newUser.Active">
            <mat-option
                *ngFor="let item of InvitationStatusCodes.ACTIVE_STATUS_VALUES"
                [value]="item.value">
                {{ item.label }}
            </mat-option>
        </mat-select>
    </mat-form-field>
</div>
<mat-divider class="st-add-team-member-divider" />

<mat-button-toggle-group class="st-add-team-member-button-group">
    <button
        mat-button
        class="st-add-team-member-button-cancel"
        (click)="cancelNew()">
        {{ languageSettings.PSTWebCancelButtonLabel }}
    </button>
    <button
        mat-button
        class="st-add-team-member-button-confirm"
        [disabled]="loading()"
        (click)="addUser()">
        <ng-template
            [ngIf]="!loading()"
            [ngIfElse]="loader">
            {{ languageSettings.PSTWebSaveMemberLabel }}
        </ng-template>
        <ng-template #loader>
            <st-loader
                class="st-add-team-member-button-confirm--spinner"
                [diameter]="30"
                [strokeWidth]="5" />
        </ng-template>
    </button>
</mat-button-toggle-group>
